import tenants from "./tenants";


let base_url;
if (process.env.NODE_ENV === "development") {
  base_url = {
    protocol: "http",
    hostname: "localhost",
    port: "8000",
    api_base_path: "/",
  };
} else {
  const host = window.location.hostname;
  const tenantKey = host.split(".")[1];

  let hostName = tenants[tenantKey]?.hostName || "floorwalk.in";
  base_url = {
    protocol: "https",
    hostname: `portal.${hostName}`,
    port: "",
    api_base_path: "/",
  };
}
export { base_url };

// Joins a base URL and an endpoint with exactly one "/" between them, so an
// endpoint may be written "audit_cycle" or "/audit_cycle". The backend (Django
// 5) needs an exact route match, so "client//audit_cycle" would 404. Only the
// boundary is touched; the "//" in "https://" is never affected.
export const joinApiPath = (base, endpoint = "") =>
  `${base.replace(/\/+$/, "")}/${String(endpoint).replace(/^\/+/, "")}`;


// export const base_url = {
// 	protocol : "https",
// 	hostname : "portal.floorwalk.in",
// 	hostname : "portal.hsbrandsasia.com",
// 	port : "",
// 	api_base_path: "/",
// };